import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { format, isValid } from 'date-fns';
import config from '../../../config';

// 숫자 포맷팅 함수
const formatNumber = num => (typeof num === 'number' ? num.toLocaleString() : num);

const IncinerationNew = ({ selectedDate }) => {
  const [data, setData] = useState({
    daily: { SO1SAN: '', SO2SAN: '', SOGHAP: '' },
    monthly: { MO1SAN: '', MO2SAN: '', MOGHAP: '' },
    operational: { SO1TIM: '', SO2TIM: '', TIMEHAP: '', MO1TIM: '', MO2TIM: '', MIMEHAP: '' },
  });
  const [loading, setLoading] = useState(false); // 로컬 로딩 상태

  // selectedDate가 Date 객체인지 확인하고 Date 객체로 변환
  const dateObj = new Date(selectedDate);
  const formattedDate = isValid(dateObj) ? format(dateObj, 'yyyyMMdd') : null;

  useEffect(() => {
    const fetchData = async () => {
      if (!formattedDate) return;

      setLoading(true);

      try {
        const response = await axios.post(
          `${config.apiUrl}/boilSel.do`,
          { stdate: formattedDate },
          { headers: { 'Content-Type': 'application/json' } },
        );

        const apiData = response.data;
        if (apiData.resultCode === 200 && Array.isArray(apiData.resultData) && apiData.resultData.length > 0) {
          const transformedData = transformData(apiData.resultData[0]);
          setData(transformedData);
        } else {
          // 데이터가 없거나 실패한 경우 빈 데이터 상태 유지
          setData({
            daily: { SO1SAN: '', SO2SAN: '', SOGHAP: '' },
            monthly: { MO1SAN: '', MO2SAN: '', MOGHAP: '' },
            operational: { SO1TIM: '', SO2TIM: '', TIMEHAP: '', MO1TIM: '', MO2TIM: '', MIMEHAP: '' },
          });
        }
      } catch (err) {
        // 오류 발생 시 빈 데이터 상태 유지
        setData({
          daily: { SO1SAN: '', SO2SAN: '', SOGHAP: '' },
          monthly: { MO1SAN: '', MO2SAN: '', MOGHAP: '' },
          operational: { SO1TIM: '', SO2TIM: '', TIMEHAP: '', MO1TIM: '', MO2TIM: '', MIMEHAP: '' },
        });
      } finally {
        setLoading(false); // 로딩 종료
      }
    };

    fetchData();
  }, [formattedDate]);

  // 데이터 변환 함수
  const transformData = apiData => ({
    daily: {
      SO1SAN: formatNumber(apiData.SO1SAN || 0),
      SO2SAN: formatNumber(apiData.SO2SAN || 0),
      SOGHAP: formatNumber(apiData.SOGHAP || 0),
    },
    monthly: {
      MO1SAN: formatNumber(apiData.MO1SAN || 0),
      MO2SAN: formatNumber(apiData.MO2SAN || 0),
      MOGHAP: formatNumber(apiData.MOGHAP || 0),
    },
    operational: {
      SO1TIM: formatNumber(apiData.SO1TIM || 0),
      SO2TIM: formatNumber(apiData.SO2TIM || 0),
      TIMEHAP: formatNumber(apiData.TIMEHAP || 0),
      MO1TIM: formatNumber(apiData.MO1TIM || 0),
      MO2TIM: formatNumber(apiData.MO2TIM || 0),
      MIMEHAP: formatNumber(apiData.MIMEHAP || 0),
    },
  });

  // 카테고리 리스트
  const categories = ['목표', '실적'];
  const operationalCategories = ['월목표', '실적(일)', '실적누계'];

  return (
    <div className=' relative mt-[4%]'>
      {loading && (
      <div className='absolute inset-0 bg-black bg-opacity-50 flex justify-center items-center z-10'>
        <div className="text-white text-2xl font-bold">Loading...</div>
      </div>
      )}
      <div className='w-[25%] change_2h page_center bg-blue-200 font-bold text-blue-600'>소각_생산량</div>
      <div className='b2-box'>
        <div className='flex flex-row'>
          {/* 상위 헤더 */}
          <div className='flex flex-col w-[25%] b2-r h-[100%]'>
            <div className='w-[100%] change_2h b2-b page_center'>구분</div>
            <div className='flex flex-col w-[100%]'>
              <div className='flex flex-row'>
                <div className='w-[40%] change_2h2 b2-r b2-b page_center border-black border-b-2 font-bold'>일</div>
                <div className='flex flex-col w-[60%]'>
                  {categories.map((category, index) => (
                    <div
                      key={index}
                      className={`w-[100%] change_2h ${
                        category === '실적' ? 'border-black border-b-2' : 'b-g'
                      } page_center`}
                    >
                      {category === '목표' ? (
                        <>
                          <div className='mx-2'>목</div>
                          <div className='mx-2'>표</div>
                        </>
                      ) : category === '실적' ? (
                        <>
                          <div className='mx-2'>실</div>
                          <div className='mx-2'>적</div>
                        </>
                      ) : (
                        category
                      )}
                    </div>
                  ))}
                </div>
              </div>
              <div className='flex flex-row'>
                <div className='w-[40%] change_2h2 b2-r b2-b page_center font-bold'>월</div>
                <div className='flex flex-col w-[60%]'>
                  {categories.map((category, index) => (
                    <div
                      key={index}
                      className={`w-[100%] change_2h ${
                        category === '실적' ? 'border-black border-b-2' : 'b-g'
                      } page_center`}
                    >
                      {category === '목표' ? (
                        <>
                          <div className='mx-2'>목</div>
                          <div className='mx-2'>표</div>
                        </>
                      ) : category === '실적' ? (
                        <>
                          <div className='mx-2'>실</div>
                          <div className='mx-2'>적</div>
                        </>
                      ) : (
                        category
                      )}
                    </div>
                  ))}
                </div>
              </div>
              <div className='flex flex-row'>
                <div className='w-[40%] change_2h3 b2-r page_center font-bold'>가동율</div>
                <div className='flex flex-col w-[60%]'>
                  {operationalCategories.map((category, index) => (
                    <div
                      key={index}
                      className={`w-[100%] change_2h page_center ${category === '실적누계' ? '' : 'b-g'}`}
                    >
                      {category}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* 1소각 */}
          <div className='flex flex-col w-[25%] b2-r h-[100%]'>
            <div className='w-[100%] change_2h b2-b page_center'>1소각</div>
            <div className='flex flex-col'>
              {/* 일 */}
              <div className={`w-[100%] change_2h b-g r-center`}></div>
              <div className={`w-[100%] change_2h b2-b r-center overflow-hidden text-ellipsis whitespace-nowrap`}>
                {data.daily.SO1SAN}
              </div>
              {/* 월 */}
              <div className={`w-[100%] change_2h b-g r-center`}></div>
              <div className={`w-[100%] change_2h b2-b r-center overflow-hidden text-ellipsis whitespace-nowrap`}>
                {data.monthly.MO1SAN}
              </div>
              {/* 가동율 */}
              <div className={`w-[100%] change_2h b-g r-center`}></div>
              <div className={`w-[100%] change_2h b-g r-center overflow-hidden text-ellipsis whitespace-nowrap`}>
                {data.operational.SO1TIM}
              </div>
              <div className={`w-[100%] change_2h  r-center overflow-hidden text-ellipsis whitespace-nowrap`}>
                {data.operational.MO1TIM}
              </div>
            </div>
          </div>

          {/* 2소각 */}
          <div className='flex flex-col w-[25%] b2-r h-[100%]'>
            <div className='w-[100%] change_2h b2-b page_center'>2소각</div>
            <div className='flex flex-col'>
              {/* 일 */}
              <div className={`w-[100%] change_2h b-g r-center`}></div>
              <div className={`w-[100%] change_2h b2-b r-center overflow-hidden text-ellipsis whitespace-nowrap`}>
                {data.daily.SO2SAN}
              </div>
              {/* 월 */}
              <div className={`w-[100%] change_2h b-g r-center`}></div>
              <div className={`w-[100%] change_2h b2-b r-center overflow-hidden text-ellipsis whitespace-nowrap`}>
                {data.monthly.MO2SAN}
              </div>
              {/* 가동율 */}
              <div className={`w-[100%] change_2h b-g r-center`}></div>
              <div className={`w-[100%] change_2h b-g r-center overflow-hidden text-ellipsis whitespace-nowrap`}>
                {data.operational.SO2TIM}
              </div>
              <div className={`w-[100%] change_2h r-center overflow-hidden text-ellipsis whitespace-nowrap`}>
                {data.operational.MO2TIM}
              </div>
            </div>
          </div>

          {/* 합계 */}
          <div className='flex flex-col w-[25%] h-[100%]'>
            <div className='w-[100%] change_2h b2-b page_center'>합계</div>
            <div className='flex flex-col'>
              {/* 일 */}
              <div className={`w-[100%]  change_2h b-g r-center`}></div>
              <div className={`w-[100%] change_2h b2-b r-center overflow-hidden text-ellipsis whitespace-nowrap`}>
                {data.daily.SOGHAP}
              </div>
              {/* 월 */}
              <div className={`w-[100%] change_2h b-g r-center`}></div>
              <div className={`w-[100%] change_2h b2-b r-center overflow-hidden text-ellipsis whitespace-nowrap`}>
                {data.monthly.MOGHAP}
              </div>
              {/* 가동율 */}
              <div className={`w-[100%] change_2h b-g r-center`}></div>
              <div className={`w-[100%] change_2h b-g r-center overflow-hidden text-ellipsis whitespace-nowrap`}>
                {data.operational.TIMEHAP}
              </div>
              <div className={`w-[100%] change_2h r-center overflow-hidden text-ellipsis whitespace-nowrap`}>
                {data.operational.MIMEHAP}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IncinerationNew;
